module.exports = __webpack_public_path__ + "static/media/momo-yaoyorozu-win.82961f10.png";